export default "__VITE_ASSET__CveXrpNP__"